/**
 * `/account/connected-agents` moved into the Settings page as the
 * "Connected apps" tab. Redirect old links/bookmarks there.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/account/connected-agents')({
  beforeLoad: () => {
    throw redirect({ to: '/account/settings', hash: 'agents', replace: true })
  },
})
